import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import getCode from '../../utils/getCode';
import Loading from '../Loading';
import ErrorScreen from '../ErrorScreen';
import { RootState } from '../../store';
import { clearApiError } from '../../store/trail';

export interface TrailLoaderParams {
  id: string;
}
const TrailLoader: React.FC = () => {
  let { id } = useParams<TrailLoaderParams>();
  const history = useHistory();
  const dispatch = useDispatch();
  const apiError = useSelector((state: RootState) => state.trail.apiError);
  const loading = useSelector((state: RootState) => state.trail.loading);

  useEffect(() => {
    getCode(id, history);
  }, [id]);

  if (apiError) {
    return (
      <ErrorScreen
        onRetry={() => {
          // Ignore rapid re-taps while a lookup is already in flight so we don't
          // dispatch concurrent getCode calls (mirrors CodeInput's loading guard).
          if (loading) return;
          dispatch(clearApiError());
          getCode(id, history);
        }}
        onHome={() => {
          dispatch(clearApiError());
          history.push('/');
        }}
      />
    );
  }

  return <Loading />;
};

export default TrailLoader;
